var render, staticRenderFns
import script from "./detail-list.vue?vue&type=script&lang=js"
export * from "./detail-list.vue?vue&type=script&lang=js"
import style0 from "./detail-list.vue?vue&type=style&index=0&id=70481fd3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports